// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AccountLinkStartEvent
 */
export var AccountLinkStart = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkAutofillEvent
 */
export var AccountLinkAutofill = function (_a) {
    var flowToken = _a.flowToken, aliasType = _a.aliasType;
    return ({
        name: "Account Link Autofill",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkApproveEvent
 */
export var AccountLinkApprove = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link Approve",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkDenyEvent
 */
export var AccountLinkDeny = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link Deny",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkSuccessEvent
 */
export var AccountLinkSuccess = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link Success",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkFailureEvent
 */
export var AccountLinkFailure = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken, errorType = _a.errorType;
    return ({
        name: "Account Link Failure",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkViewOfferEvent
 *
 * @deprecated This event is no longer needed.
 */
export var AccountLinkViewOffer = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken;
    return ({
        name: "Account Link ViewOffer",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkDismissOfferEvent
 */
export var AccountLinkDismissOffer = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link DismissOffer",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountLinkUpdateAppEvent
 */
export var AccountLinkUpdateApp = function (_a) {
    var accountLinkType = _a.accountLinkType, thirdPartyUserId = _a.thirdPartyUserId, brandToken = _a.brandToken, merchantToken = _a.merchantToken, offerId = _a.offerId, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Account Link UpdateApp",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Link",
            account_link_type: accountLinkType !== undefined && accountLinkType !== null ? accountLinkType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_party_user_id: thirdPartyUserId !== undefined && thirdPartyUserId !== null ? thirdPartyUserId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            brand_token: brandToken !== undefined && brandToken !== null ? brandToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            merchant_token: merchantToken !== undefined && merchantToken !== null ? merchantToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            offer_id: offerId !== undefined && offerId !== null ? offerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInStartEvent
 */
export var AccountSignInStart = function (_a) {
    var aliasPrefilled = _a.aliasPrefilled, aliasType = _a.aliasType, countryCodeSelectorEnabled = _a.countryCodeSelectorEnabled, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_prefilled: aliasPrefilled !== undefined && aliasPrefilled !== null ? aliasPrefilled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            country_code_selector_enabled: countryCodeSelectorEnabled !== undefined && countryCodeSelectorEnabled !== null ? countryCodeSelectorEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInSwitchAliasEntryTypeEvent
 */
export var AccountSignInSwitchAliasEntryType = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn SwitchAliasEntryType",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInMagicLinkCompleteEvent
 */
export var AccountSignInMagicLinkComplete = function (_a) {
    var flowToken = _a.flowToken, result = _a.result;
    return ({
        name: "Account SignIn MagicLinkComplete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInRequireHelpEvent
 */
export var AccountSignInRequireHelp = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn RequireHelp",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInViewTermsEvent
 */
export var AccountSignInViewTerms = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn ViewTerms",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInReceiveErrorEvent
 */
export var AccountSignInReceiveError = function (_a) {
    var aliasType = _a.aliasType, errorType = _a.errorType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn ReceiveError",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInReceiveTokenEvent
 */
export var AccountSignInReceiveToken = function (_a) {
    var hasExistingLinkedAccounts = _a.hasExistingLinkedAccounts;
    return ({
        name: "Account SignIn ReceiveToken",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            has_existing_linked_accounts: hasExistingLinkedAccounts !== undefined && hasExistingLinkedAccounts !== null ? hasExistingLinkedAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInDetermineSignInTypeEvent
 */
export var AccountSignInDetermineSignInType = function (_a) {
    var signInType = _a.signInType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn DetermineSignInType",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            sign_in_type: signInType !== undefined && signInType !== null ? signInType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInCompleteEvent
 */
export var AccountSignInComplete = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn Complete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInOpenCountryCodeSelectorEvent
 */
export var AccountSignInOpenCountryCodeSelector = function (_a) {
    var currentSelectedCountryCode = _a.currentSelectedCountryCode, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn OpenCountryCodeSelector",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            current_selected_country_code: currentSelectedCountryCode !== undefined && currentSelectedCountryCode !== null ? currentSelectedCountryCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSignInCountryCodeSelectedEvent
 */
export var AccountSignInCountryCodeSelected = function (_a) {
    var currentSelectedCountryCode = _a.currentSelectedCountryCode, newSelectedCountryCode = _a.newSelectedCountryCode, flowToken = _a.flowToken;
    return ({
        name: "Account SignIn CountryCodeSelected",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SignIn",
            current_selected_country_code: currentSelectedCountryCode !== undefined && currentSelectedCountryCode !== null ? currentSelectedCountryCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            new_selected_country_code: newSelectedCountryCode !== undefined && newSelectedCountryCode !== null ? newSelectedCountryCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRegisterStartEvent
 *
 * @deprecated Use `AliasRegisterStart` instead.
 */
export var AccountRegisterStart = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering;
    return ({
        name: "Account Register Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRegisterGenerateTokenEvent
 *
 * @deprecated Use `AliasRegisterGenerateToken` instead.
 */
export var AccountRegisterGenerateToken = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Register GenerateToken",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRegisterReceiveErrorEvent
 *
 * @deprecated Use `AliasRegisterReceiveError` instead.
 */
export var AccountRegisterReceiveError = function (_a) {
    var aliasType = _a.aliasType, errorType = _a.errorType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering;
    return ({
        name: "Account Register ReceiveError",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRegisterCompleteEvent
 *
 * @deprecated Use `AliasRegisterComplete` instead.
 */
export var AccountRegisterComplete = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering;
    return ({
        name: "Account Register Complete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRegisterTransferAssetsEvent
 */
export var AccountRegisterTransferAssets = function (_a) {
    var transferType = _a.transferType;
    return ({
        name: "Account Register TransferAssets",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Register",
            transfer_type: transferType !== undefined && transferType !== null ? transferType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyStartEvent
 *
 * @deprecated Use `AliasVerifyStart` instead.
 */
export var AccountVerifyStart = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyReceiveVerificationCodeEvent
 *
 * @deprecated Use `AliasVerifyReceiveVerificationCode` instead.
 */
export var AccountVerifyReceiveVerificationCode = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify ReceiveVerificationCode",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyReportVerificationCodeNotReceivedEvent
 *
 * @deprecated Introduce and use `AliasVerifyReportVerificationCodeNotReceived` instead if needed.
 */
export var AccountVerifyReportVerificationCodeNotReceived = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, startListeningForVerificationCodesTimeMillis = _a.startListeningForVerificationCodesTimeMillis, secondsElapsed = _a.secondsElapsed;
    return ({
        name: "Account Verify ReportVerificationCodeNotReceived",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            start_listening_for_verification_codes_time_millis: startListeningForVerificationCodesTimeMillis !== undefined && startListeningForVerificationCodesTimeMillis !== null ? startListeningForVerificationCodesTimeMillis.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            seconds_elapsed: secondsElapsed !== undefined && secondsElapsed !== null ? secondsElapsed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyReceiveErrorEvent
 *
 * @deprecated Use `AliasVerifyReceiveError` instead.
 */
export var AccountVerifyReceiveError = function (_a) {
    var aliasType = _a.aliasType, errorType = _a.errorType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify ReceiveError",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyRequireHelpEvent
 *
 * @deprecated Use `AliasVerifyRequireHelp` instead.
 */
export var AccountVerifyRequireHelp = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify RequireHelp",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyResendEvent
 *
 * @deprecated Use `AliasVerifyResend` instead.
 */
export var AccountVerifyResend = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify Resend",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyEditAliasEvent
 *
 * @deprecated Introduce and use `AliasVerifyEditAlias` instead if needed.
 */
export var AccountVerifyEditAlias = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify EditAlias",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyCallPhoneNumberEvent
 *
 * @deprecated Use `AliasVerifyCallPhoneNumber` instead.
 */
export var AccountVerifyCallPhoneNumber = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Account Verify CallPhoneNumber",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifySkipEvent
 *
 * @deprecated Use `AliasVerifySkip` instead.
 */
export var AccountVerifySkip = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify Skip",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountVerifyCompleteEvent
 *
 * @deprecated Use `AliasVerifyComplete` instead.
 */
export var AccountVerifyComplete = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account Verify Complete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureSyncContactsEvent
 */
export var AccountConfigureSyncContacts = function (_a) {
    var enabled = _a.enabled;
    return ({
        name: "Account Configure SyncContacts",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureGrantContactPermissionsEvent
 */
export var AccountConfigureGrantContactPermissions = function (_a) {
    var enabled = _a.enabled, flowToken = _a.flowToken;
    return ({
        name: "Account Configure GrantContactPermissions",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureEnablePasscodeEvent
 */
export var AccountConfigureEnablePasscode = function () { return ({
    name: "Account Configure EnablePasscode",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "Configure",
    }
}); };
/**
 * @see AccountConfigureDisablePasscodeEvent
 */
export var AccountConfigureDisablePasscode = function () { return ({
    name: "Account Configure DisablePasscode",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "Configure",
    }
}); };
/**
 * @see AccountConfigureAcceptTermsEvent
 */
export var AccountConfigureAcceptTerms = function (_a) {
    var acceptanceType = _a.acceptanceType, acceptedAt = _a.acceptedAt, version = _a.version;
    return ({
        name: "Account Configure AcceptTerms",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            acceptance_type: acceptanceType !== undefined && acceptanceType !== null ? acceptanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            accepted_at: acceptedAt !== undefined && acceptedAt !== null ? acceptedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            version: version !== undefined && version !== null ? version.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureUpdateNotificationPreferenceEvent
 */
export var AccountConfigureUpdateNotificationPreference = function (_a) {
    var aliasType = _a.aliasType, enabled = _a.enabled;
    return ({
        name: "Account Configure UpdateNotificationPreference",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureUpdateAppMessagesPreferenceEvent
 */
export var AccountConfigureUpdateAppMessagesPreference = function (_a) {
    var enabled = _a.enabled;
    return ({
        name: "Account Configure UpdateAppMessagesPreference",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountConfigureSearchPrivacySettingEvent
 */
export var AccountConfigureSearchPrivacySetting = function (_a) {
    var customerToken = _a.customerToken, settingName = _a.settingName, value = _a.value;
    return ({
        name: "Account Configure SearchPrivacySetting",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Configure",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            setting_name: settingName !== undefined && settingName !== null ? settingName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value: value !== undefined && value !== null ? value.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateBiometricsEnrollmentEvent
 */
export var AccountAuthenticateBiometricsEnrollment = function (_a) {
    var supportedBiometryType = _a.supportedBiometryType, result = _a.result;
    return ({
        name: "Account Authenticate BiometricsEnrollment",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            supported_biometry_type: supportedBiometryType !== undefined && supportedBiometryType !== null ? supportedBiometryType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateStartEvent
 */
export var AccountAuthenticateStart = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, supportedBiometryType = _a.supportedBiometryType, currentBiometryState = _a.currentBiometryState, authenticationTokenExists = _a.authenticationTokenExists;
    return ({
        name: "Account Authenticate Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            supported_biometry_type: supportedBiometryType !== undefined && supportedBiometryType !== null ? supportedBiometryType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_biometry_state: currentBiometryState !== undefined && currentBiometryState !== null ? currentBiometryState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            authentication_token_exists: authenticationTokenExists !== undefined && authenticationTokenExists !== null ? authenticationTokenExists.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateBiometricsPromptEvent
 */
export var AccountAuthenticateBiometricsPrompt = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, supportedBiometryType = _a.supportedBiometryType;
    return ({
        name: "Account Authenticate BiometricsPrompt",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            supported_biometry_type: supportedBiometryType !== undefined && supportedBiometryType !== null ? supportedBiometryType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateBiometricsCompleteEvent
 */
export var AccountAuthenticateBiometricsComplete = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, biometryTypeUsed = _a.biometryTypeUsed, result = _a.result, attemptCount = _a.attemptCount, additionalInfo = _a.additionalInfo;
    return ({
        name: "Account Authenticate BiometricsComplete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            biometry_type_used: biometryTypeUsed !== undefined && biometryTypeUsed !== null ? biometryTypeUsed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_count: attemptCount !== undefined && attemptCount !== null ? attemptCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            additional_info: additionalInfo !== undefined && additionalInfo !== null ? additionalInfo.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticatePasscodePromptEvent
 */
export var AccountAuthenticatePasscodePrompt = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken;
    return ({
        name: "Account Authenticate PasscodePrompt",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateSubmitCredentialEvent
 */
export var AccountAuthenticateSubmitCredential = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, inputDurationMs = _a.inputDurationMs, credentialType = _a.credentialType;
    return ({
        name: "Account Authenticate SubmitCredential",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            input_duration_ms: inputDurationMs !== undefined && inputDurationMs !== null ? inputDurationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            credential_type: credentialType !== undefined && credentialType !== null ? credentialType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateCompleteEvent
 */
export var AccountAuthenticateComplete = function (_a) {
    var clientScenario = _a.clientScenario, flowToken = _a.flowToken, result = _a.result, attemptCount = _a.attemptCount;
    return ({
        name: "Account Authenticate Complete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            attempt_count: attemptCount !== undefined && attemptCount !== null ? attemptCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticatePasswordPromptEvent
 */
export var AccountAuthenticatePasswordPrompt = function () { return ({
    name: "Account Authenticate PasswordPrompt",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "Authenticate",
    }
}); };
/**
 * @see AccountAuthenticatePasswordVisiblityToggleEvent
 */
export var AccountAuthenticatePasswordVisiblityToggle = function (_a) {
    var toggleState = _a.toggleState;
    return ({
        name: "Account Authenticate PasswordVisiblityToggle",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            toggleState: toggleState !== undefined && toggleState !== null ? toggleState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticatePasswordBiometricsToggleEvent
 */
export var AccountAuthenticatePasswordBiometricsToggle = function (_a) {
    var toggleState = _a.toggleState;
    return ({
        name: "Account Authenticate PasswordBiometricsToggle",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            toggleState: toggleState !== undefined && toggleState !== null ? toggleState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticatePasswordCreateEvent
 */
export var AccountAuthenticatePasswordCreate = function () { return ({
    name: "Account Authenticate PasswordCreate",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "Authenticate",
    }
}); };
/**
 * @see AccountAuthenticatePasswordUpdateEvent
 */
export var AccountAuthenticatePasswordUpdate = function () { return ({
    name: "Account Authenticate PasswordUpdate",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "Authenticate",
    }
}); };
/**
 * @see AccountAuthenticateTotpToggleEvent
 */
export var AccountAuthenticateTotpToggle = function (_a) {
    var state = _a.state;
    return ({
        name: "Account Authenticate TotpToggle",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateViewLockSplashScreenEvent
 */
export var AccountAuthenticateViewLockSplashScreen = function (_a) {
    var threshold = _a.threshold, uiAccessAvailable = _a.uiAccessAvailable;
    return ({
        name: "Account Authenticate ViewLockSplashScreen",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            threshold: threshold !== undefined && threshold !== null ? threshold.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ui_access_available: uiAccessAvailable !== undefined && uiAccessAvailable !== null ? uiAccessAvailable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAuthenticateDismissLockSplashScreenEvent
 */
export var AccountAuthenticateDismissLockSplashScreen = function (_a) {
    var threshold = _a.threshold, duration = _a.duration, securityCheckpointState = _a.securityCheckpointState;
    return ({
        name: "Account Authenticate DismissLockSplashScreen",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Authenticate",
            threshold: threshold !== undefined && threshold !== null ? threshold.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration: duration !== undefined && duration !== null ? duration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            securityCheckpointState: securityCheckpointState !== undefined && securityCheckpointState !== null ? securityCheckpointState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountRecoveryStartEvent
 */
export var AccountRecoveryStart = function (_a) {
    var clientScenario = _a.clientScenario, entryPoint = _a.entryPoint, flowToken = _a.flowToken;
    return ({
        name: "Account Recovery Start",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Recovery",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountReturningLoginSkipAccountSelectionEvent
 */
export var AccountReturningLoginSkipAccountSelection = function () { return ({
    name: "Account ReturningLogin SkipAccountSelection",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "ReturningLogin",
    }
}); };
/**
 * @see AccountReturningLoginAccountListLoadedEvent
 */
export var AccountReturningLoginAccountListLoaded = function (_a) {
    var numberOfAccounts = _a.numberOfAccounts;
    return ({
        name: "Account ReturningLogin AccountListLoaded",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "ReturningLogin",
            number_of_accounts: numberOfAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see AccountReturningLoginAccountPickerShownEvent
 */
export var AccountReturningLoginAccountPickerShown = function (_a) {
    var numberOfAccounts = _a.numberOfAccounts;
    return ({
        name: "Account ReturningLogin AccountPickerShown",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "ReturningLogin",
            number_of_accounts: numberOfAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see AccountReturningLoginAliasPickerShownEvent
 */
export var AccountReturningLoginAliasPickerShown = function (_a) {
    var numberOfAliases = _a.numberOfAliases, preferredAliasExists = _a.preferredAliasExists;
    return ({
        name: "Account ReturningLogin AliasPickerShown",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "ReturningLogin",
            number_of_aliases: numberOfAliases.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            preferred_alias_exists: preferredAliasExists.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see AccountReturningLoginLoginAttemptedEvent
 */
export var AccountReturningLoginLoginAttempted = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account ReturningLogin LoginAttempted",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "ReturningLogin",
            alias_type: aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            flow_token: flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see AccountReturningLoginLoginSuccessEvent
 */
export var AccountReturningLoginLoginSuccess = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Account ReturningLogin LoginSuccess",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "ReturningLogin",
            alias_type: aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            flow_token: flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
/**
 * @see AccountSwitchAccountViewAddAccountEvent
 */
export var AccountSwitchAccountViewAddAccount = function (_a) {
    var flowToken = _a.flowToken, canAddPersonalAccount = _a.canAddPersonalAccount, canAddBusinessAccount = _a.canAddBusinessAccount, canLinkAccounts = _a.canLinkAccounts;
    return ({
        name: "Account SwitchAccount ViewAddAccount",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_add_personal_account: canAddPersonalAccount !== undefined && canAddPersonalAccount !== null ? canAddPersonalAccount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_add_business_account: canAddBusinessAccount !== undefined && canAddBusinessAccount !== null ? canAddBusinessAccount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_link_accounts: canLinkAccounts !== undefined && canLinkAccounts !== null ? canLinkAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountViewSwitcherEvent
 */
export var AccountSwitchAccountViewSwitcher = function (_a) {
    var flowToken = _a.flowToken, showsAddAccount = _a.showsAddAccount, entryPoint = _a.entryPoint;
    return ({
        name: "Account SwitchAccount ViewSwitcher",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            shows_add_account: showsAddAccount !== undefined && showsAddAccount !== null ? showsAddAccount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountFetchAccountsAttemptEvent
 */
export var AccountSwitchAccountFetchAccountsAttempt = function () { return ({
    name: "Account SwitchAccount FetchAccountsAttempt",
    parameters: {
        cdf_entity: "Account",
        cdf_action: "SwitchAccount",
    }
}); };
/**
 * @see AccountSwitchAccountFetchAccountsSuccessEvent
 */
export var AccountSwitchAccountFetchAccountsSuccess = function (_a) {
    var accountTokensReturned = _a.accountTokensReturned;
    return ({
        name: "Account SwitchAccount FetchAccountsSuccess",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            account_tokens_returned: accountTokensReturned !== undefined && accountTokensReturned !== null ? accountTokensReturned.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountFetchAccountsErrorEvent
 */
export var AccountSwitchAccountFetchAccountsError = function (_a) {
    var errorMessage = _a.errorMessage, errorCode = _a.errorCode;
    return ({
        name: "Account SwitchAccount FetchAccountsError",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_code: errorCode !== undefined && errorCode !== null ? errorCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountSelectAddAccountEvent
 */
export var AccountSwitchAccountSelectAddAccount = function (_a) {
    var flowToken = _a.flowToken, accountType = _a.accountType;
    return ({
        name: "Account SwitchAccount SelectAddAccount",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            account_type: accountType !== undefined && accountType !== null ? accountType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountSelectExistingAccountEvent
 */
export var AccountSwitchAccountSelectExistingAccount = function (_a) {
    var flowToken = _a.flowToken, accountToken = _a.accountToken;
    return ({
        name: "Account SwitchAccount SelectExistingAccount",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            account_token: accountToken !== undefined && accountToken !== null ? accountToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountAccountSwitchServerRequestCompleteEvent
 */
export var AccountSwitchAccountAccountSwitchServerRequestComplete = function (_a) {
    var flowToken = _a.flowToken, loggedOutAccountToken = _a.loggedOutAccountToken, loggedInAccountToken = _a.loggedInAccountToken, durationMs = _a.durationMs, source = _a.source, result = _a.result, error = _a.error;
    return ({
        name: "Account SwitchAccount AccountSwitchServerRequestComplete",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logged_out_account_token: loggedOutAccountToken !== undefined && loggedOutAccountToken !== null ? loggedOutAccountToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logged_in_account_token: loggedInAccountToken !== undefined && loggedInAccountToken !== null ? loggedInAccountToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_ms: durationMs !== undefined && durationMs !== null ? durationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error: error !== undefined && error !== null ? error.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountAccountSwitchedEvent
 */
export var AccountSwitchAccountAccountSwitched = function (_a) {
    var flowToken = _a.flowToken, loggedOutAccountToken = _a.loggedOutAccountToken, loggedInAccountToken = _a.loggedInAccountToken, durationMs = _a.durationMs, source = _a.source, jvmHeapBytes = _a.jvmHeapBytes, nativeHeapBytes = _a.nativeHeapBytes;
    return ({
        name: "Account SwitchAccount AccountSwitched",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logged_out_account_token: loggedOutAccountToken !== undefined && loggedOutAccountToken !== null ? loggedOutAccountToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            logged_in_account_token: loggedInAccountToken !== undefined && loggedInAccountToken !== null ? loggedInAccountToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_ms: durationMs !== undefined && durationMs !== null ? durationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            jvmHeapBytes: jvmHeapBytes !== undefined && jvmHeapBytes !== null ? jvmHeapBytes.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            nativeHeapBytes: nativeHeapBytes !== undefined && nativeHeapBytes !== null ? nativeHeapBytes.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountAccountSwitchErrorEvent
 */
export var AccountSwitchAccountAccountSwitchError = function (_a) {
    var errorMessage = _a.errorMessage;
    return ({
        name: "Account SwitchAccount AccountSwitchError",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            error_message: errorMessage !== undefined && errorMessage !== null ? errorMessage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountSwitchAccountViewConfirmationToastEvent
 */
export var AccountSwitchAccountViewConfirmationToast = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Account SwitchAccount ViewConfirmationToast",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "SwitchAccount",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountCleanupCleanupStartedEvent
 */
export var AccountCleanupCleanupStarted = function (_a) {
    var style = _a.style;
    return ({
        name: "Account Cleanup CleanupStarted",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Cleanup",
            style: style !== undefined && style !== null ? style.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountCleanupCleanupCompletedEvent
 */
export var AccountCleanupCleanupCompleted = function (_a) {
    var style = _a.style, durationMs = _a.durationMs;
    return ({
        name: "Account Cleanup CleanupCompleted",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Cleanup",
            style: style !== undefined && style !== null ? style.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_ms: durationMs !== undefined && durationMs !== null ? durationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountAwareRoutingFetchedAccountsEvent
 */
export var AccountAwareRoutingFetchedAccounts = function (_a) {
    var fetchResult = _a.fetchResult;
    return ({
        name: "Account AwareRouting FetchedAccounts",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "AwareRouting",
            fetch_result: fetchResult !== undefined && fetchResult !== null ? fetchResult.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AccountViewedSearchPrivacySettingEvent
 */
export var AccountViewedSearchPrivacySetting = function (_a) {
    var customerToken = _a.customerToken;
    return ({
        name: "Account Viewed SearchPrivacySetting",
        parameters: {
            cdf_entity: "Account",
            cdf_action: "Viewed",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
